import Immutable from 'immutable'
import GroupMenu from './group_menu'

export default class DailyMenu
  constructor: (@canteen, @date, @_groupMenus, @_menu) ->

  groupMenus: ->
    @_groupMenus?.map(@_groupMenuFor.bind(@)).valueSeq() or new Immutable.Seq

  groupNames: ->
    @_groupMenus?.keySeq() or new Immutable.Seq

  hasMeals: ->
    @_groupMenus?

  _groupMenuFor: (courseMenus, groupName) ->
    group = @_menu.groups.find(groupName)

    new GroupMenu(@canteen, @date, group, courseMenus, @_menu)
